import { Button } from '@/components/shadcn/button'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Suspense, useState } from 'react'
import { ActivityLogV2Props } from '../ActivityLogV2'
import { NextStepHeading } from './NextStepHeading'
import { ReturnFileComponent } from './ReturnFileComponent'
import { usePostTransitionUpdate } from './usePostTransitionUpdate'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'

type LogItem = RestSchemas['Messages.DataAssets.TDataAssetActivity']

export function CompletedAction({
  entityId,
  dataAssetId,
  lastActivity,
}: ActivityLogV2Props & { lastActivity: LogItem }) {
  return (
    <>
      <NextStepHeading>Process is completed</NextStepHeading>
      <Suspense fallback={<div>Loading...</div>}>
        <CompletedActionContents entityId={entityId} dataAssetId={dataAssetId} lastActivity={lastActivity} />
      </Suspense>
    </>
  )
}

function CompletedActionContents({
  entityId,
  dataAssetId,
  lastActivity,
}: ActivityLogV2Props & { lastActivity: LogItem }) {
  const [returnClicked, setReturnClicked] = useState(false)
  const { isPending } = usePostTransitionUpdate({ entityId, dataAssetId })

  const onCancel = () => {
    setReturnClicked(false)
  }

  if (isPending) {
    return (
      <div className="flex w-full items-center justify-center gap-x-2 py-6">
        <IconTransformOutline className="size-6 animate-spin text-primary" />
        <p className="text-sm">Uploading...</p>
      </div>
    )
  }

  if (returnClicked) {
    return <ReturnFileComponent entityId={entityId} dataAssetId={dataAssetId} onCancel={onCancel} />
  }
  return (
    <div>
      <Button
        disabled={!lastActivity.data_asset.allow_discard}
        variant="outline"
        className="h-7"
        size="sm"
        onClick={() => setReturnClicked(true)}
      >
        <IconV2ArrowLeftOutline className="mr-1 size-3" />
        Return file?
      </Button>
    </div>
  )
}
